export default {
    q: '',
    officeExisted: false,
    officeAdded: false,
    officeList: [],
    offices: [],
    currentTimezone: false,

    addOffice(item) {
        if (this.offices.filter(function (e) {
            return e.city_id === item.city_id;
        }).length === 0) {
            this.q = '';
            this.offices.push({
                isDefault: this.offices.length === 0,
                text: `${item.country}, ${item.name} ${item.gmt_offset} (${item.abbreviation})`,
                zone: item.zone_name,
                city_id: item.city_id
            });
            this.officeAdded = true;
        } else {
            this.officeExisted = true;
            this.officeAdded = false;
        }
    },

    removeOffice(key) {
        let defaultOfficeDeleted = this.offices[key].isDefault;

        this.offices = this.offices.filter(function (office, keyTz) {
            return keyTz !== key;
        });

        if (defaultOfficeDeleted) {
            this.offices[0].isDefault = true;
        }
    },

    setDefaultOffice(key) {
        this.offices.map((office, keyTz) => {
            office.isDefault = (keyTz === key);
        })
    },

    preparedApiRequest() {
        let req = [];

        this.offices.map(item => {
            req.push({
                city_id: item.city_id,
                default: item.isDefault
            });
        });

        return req;
    }
}
